package twist.mena.sports.admin.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import twist.mena.sports.admin.theme.Spacing
import org.jetbrains.compose.web.attributes.AttrsScope
import org.w3c.dom.HTMLIFrameElement

@Composable
fun MobilePreview(clientUrl: String) {
    Div({
        style {
            width(420.px)
            backgroundColor(Color("#111827"))
            padding(Spacing.xl)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            property("position", "fixed")
            property("right", "0")
            property("top", "64px")
            property("bottom", "0")
            property("z-index", "40")
            property("border-left", "1px solid #1f2937")
        }
    }) {
        // Phone frame
        Div({
            style {
                width(375.px)
                property("max-height", "calc(100vh - 140px)")
                height(812.px)
                backgroundColor(Color("#1f2937"))
                borderRadius(40.px)
                property("box-shadow", "0 25px 50px -12px rgba(0, 0, 0, 0.5)")
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                overflow("hidden")
                property("position", "relative")
            }
        }) {
            // Notch
            Div({
                style {
                    width(120.px)
                    height(28.px)
                    backgroundColor(Color("#1f2937"))
                    property("border-radius", "0 0 14px 14px")
                    property("position", "absolute")
                    property("top", "0")
                    property("left", "50%")
                    property("transform", "translateX(-50%)")
                    property("z-index", "10")
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                }
            }) {
                // Camera dot
                Div({
                    style {
                        width(10.px)
                        height(10.px)
                        borderRadius(50.percent)
                        backgroundColor(Color("#374151"))
                    }
                })
            }

            // Screen area
            Div({
                style {
                    flex(1)
                    margin(8.px)
                    borderRadius(32.px)
                    overflow("hidden")
                    backgroundColor(Color("#121316"))
                }
            }) {
                Iframe({
                    attr("src", clientUrl)
                    attr("frameborder", "0")
                    attr("allow", "fullscreen")
                    style {
                        width(100.percent)
                        height(100.percent)
                        property("border", "none")
                        property("border-radius", "32px")
                    }
                })
            }

            // Home indicator
            Div({
                style {
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.Center)
                    padding(8.px, 0.px, 6.px, 0.px)
                }
            }) {
                Div({
                    style {
                        width(134.px)
                        height(5.px)
                        borderRadius(3.px)
                        backgroundColor(Color("#4b5563"))
                    }
                })
            }
        }
    }
}
